import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SelectionStateService } from './selection-state.service';
import { APP_ROUTES } from '../types/app-routes';

/**
 * Administración fija su propio rol según `/me` (administrator si business_admin, si no
 * sales-manager), sin evento. Corre antes que `administrationAccessGuard`, que lee ese rol.
 * Un `sellers` sin permisos vuelve al dashboard; los demás perfiles no cambian.
 */
export const administrationContextGuard: CanActivateFn = async () => {
  const state = inject(SelectionStateService);
  const router = inject(Router);
  await state.whenProfileReady();

  if (!state.isSellersUser()) {
    return true;
  }
  const role = state.administrationRole();
  if (!role) {
    return router.createUrlTree([APP_ROUTES.DASHBOARD_SELLER]);
  }
  await state.setAdministrationContext(role);
  return true;
};
